import { View } from 'react-native';
import React from 'react';
import { MyRouter } from './src/MyRouter';

export default function App() {
  return (
<View>
  <MyRouter></MyRouter>
</View>
  );
}

